/* SkyCase — el bundle y sus backboards se comportan como una unidad.
 * 1. Al eliminar el bundle, sus backboards se van con él.
 * 2. Al cambiar la cantidad del bundle, los backboards la siguen.
 *    (cada slot — 2nd, 3rd — es una línea aparte, una por bundle,
 *     así que la cantidad de cada add-on = la cantidad del bundle)
 * 3. Red de seguridad al cargar /cart: limpia backboards huérfanos y
 *    reconcilia cualquier descuadre que se haya colado por otro camino.
 *
 * Con más de una línea de bundle no se interviene: no hay forma de saber
 * qué backboard pertenece a cuál, así que se deja el comportamiento nativo.
 * Se enlaza desde snippets/meta-tags.liquid.
 *
 * OJO: Dawn pinta DOS enlaces al producto por fila del carrito (la imagen
 * y el título). Contar enlaces para saber cuántos bundles hay da el doble.
 * Por eso se cuentan filas .cart-item, no enlaces.
 */
(function () {
  var ADDON = 'extra-magnetic-backboard';
  var BUNDLE = 'skycase-critical-error-world-complete-case';

  function esAddon(i) {
    return i.handle === ADDON;
  }

  function esBundle(i) {
    return i.handle === BUNDLE;
  }

  function leerCarrito() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function actualizar(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  /* Cuenta FILAS del carrito que contienen un enlace a ese producto.
     Síncrona, para decidir si intervenir antes de cancelar el evento. */
  function filasCon(handle) {
    return Array.prototype.filter.call(document.querySelectorAll('.cart-item'), function (fila) {
      return !!fila.querySelector('a[href*="/products/' + handle + '"]');
    }).length;
  }

  /* Devuelve la fila .cart-item si el elemento pertenece a un bundle */
  function filaDeBundle(el) {
    if (!el || !el.closest) return null;
    var fila = el.closest('.cart-item');
    if (!fila) return null;
    if (!fila.querySelector('a[href*="/products/' + BUNDLE + '"]')) return null;
    return fila;
  }

  /* ¿Debemos hacernos cargo de este carrito? Un solo bundle y con extras. */
  function nosHacemosCargo() {
    return filasCon(BUNDLE) === 1 && filasCon(ADDON) > 0;
  }

  /* Deja el bundle en `nueva` y pone todos sus backboards en la misma
     cantidad. Si `nueva` es 0 o menos, se va todo junto. */
  function aplicarCantidad(nueva) {
    return leerCarrito().then(function (cart) {
      var bundles = cart.items.filter(esBundle);
      if (bundles.length !== 1) return null;

      var updates = {};
      if (nueva <= 0) {
        cart.items.forEach(function (i) {
          if (esBundle(i) || esAddon(i)) updates[i.key] = 0;
        });
      } else {
        updates[bundles[0].key] = nueva;
        cart.items.forEach(function (i) {
          if (esAddon(i)) updates[i.key] = nueva;
        });
      }
      return actualizar(updates);
    });
  }

  function recargarCarrito() {
    window.location.href = '/cart';
  }

  /* 1. Eliminar el bundle arrastra sus backboards */
  document.addEventListener(
    'click',
    function (e) {
      var enlace = e.target.closest && e.target.closest('a[href*="/cart/change"]');
      if (!enlace) return;
      var href = enlace.getAttribute('href') || '';
      if (href.indexOf('quantity=0') === -1) return;
      if (!filaDeBundle(enlace)) return;
      if (!nosHacemosCargo()) return;

      e.preventDefault();
      e.stopPropagation();

      aplicarCantidad(0).then(recargarCarrito).catch(function () {
        window.location.href = href;
      });
    },
    true
  );

  /* 2a. Botones + / − en la línea del bundle */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('button[name="plus"], button[name="minus"]');
      if (!btn) return;
      var fila = filaDeBundle(btn);
      if (!fila) return;
      if (!nosHacemosCargo()) return;

      var input = fila.querySelector('.quantity__input');
      if (!input) return;
      var actual = parseInt(input.value, 10);
      if (isNaN(actual)) return;
      var nueva = btn.getAttribute('name') === 'plus' ? actual + 1 : actual - 1;

      e.preventDefault();
      e.stopPropagation();

      aplicarCantidad(nueva).then(recargarCarrito).catch(recargarCarrito);
    },
    true
  );

  /* 2b. Cantidad escrita a mano en la línea del bundle */
  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
      if (!filaDeBundle(input)) return;
      if (!nosHacemosCargo()) return;

      var nueva = parseInt(input.value, 10);
      if (isNaN(nueva)) return;

      e.preventDefault();
      e.stopPropagation();

      aplicarCantidad(nueva).then(recargarCarrito).catch(recargarCarrito);
    },
    true
  );

  /* 3. Red de seguridad al cargar /cart */
  if (window.location.pathname.indexOf('/cart') === 0) {
    leerCarrito()
      .then(function (cart) {
        var addons = cart.items.filter(esAddon);
        if (addons.length === 0) return;

        var bundles = cart.items.filter(esBundle);
        var updates = {};

        if (bundles.length === 0) {
          /* backboards huérfanos: fuera */
          addons.forEach(function (i) {
            updates[i.key] = 0;
          });
        } else if (bundles.length === 1) {
          /* descuadre: los backboards siguen al bundle */
          var q = bundles[0].quantity;
          addons.forEach(function (i) {
            if (i.quantity !== q) updates[i.key] = q;
          });
        }

        if (Object.keys(updates).length === 0) return;
        return actualizar(updates).then(function () {
          window.location.reload();
        });
      })
      .catch(function () {});
  }
})();
